import { useEffect, useState } from "react";

/**
 * Session for an account created at checkout (phone + password, no QR yet). Kept apart from the
 * QR owner session (`locket_jwt`) because it can only place and view orders.
 */
const KEY = "order_account_session";
const TTL_MS = 7 * 24 * 60 * 60 * 1000;
const CHANGE_EVENT = "orderSessionChanged";
export const CUSTOMER_SIGNED_OUT_EVENT = "customerSignedOut";

export function getOrderSession() {
  try {
    const session = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!session?.token || Date.now() >= session.expiresAt) {
      localStorage.removeItem(KEY);
      return null;
    }
    return session;
  } catch {
    localStorage.removeItem(KEY);
    return null;
  }
}

/** account: { name, phone } */
export function saveOrderSession(token, account) {
  if (localStorage.getItem("locket_jwt")) {
    localStorage.removeItem("locket_jwt");
    localStorage.removeItem("locket_jwt_expiry");
    window.dispatchEvent(new Event(CUSTOMER_SIGNED_OUT_EVENT));
  }
  const session = { token, account, expiresAt: Date.now() + TTL_MS };
  localStorage.setItem(KEY, JSON.stringify(session));
  window.dispatchEvent(new Event(CHANGE_EVENT));
  return session;
}

export function clearOrderSession() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(CHANGE_EVENT));
}

export function orderAuthHeaders(session) {
  return session?.token ? { Authorization: `Bearer ${session.token}` } : {};
}

/** Current checkout-account session; re-renders when it is saved or cleared anywhere in the app. */
export function useOrderSession() {
  const [session, setSession] = useState(getOrderSession);
  useEffect(() => {
    const sync = () => setSession(getOrderSession());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return session;
}
